export default class ClientCredential {
    credentialNumber: string
    vacancyId: number
    
    constructor(credentialNumber, vacancyId) {
        this.credentialNumber = credentialNumber
        this.vacancyId = vacancyId
    }
}